import { z } from "zod";
const textNodeSchema = z.object({
  type: z.literal("text"),
  text: z.string()
});
const placeholderNodeSchema = z.object({
  type: z.literal("placeholder"),
  attrs: z.object({ name: z.string() })
});
const inlineNodeSchema = z.union([
  textNodeSchema,
  placeholderNodeSchema
]);
const paragraphNodeSchema = z.object({
  type: z.literal("paragraph"),
  content: z.array(inlineNodeSchema)
});
const singleLineContentSchema = z.object({
  content: z.array(inlineNodeSchema)
});
const multilineContentSchema = z.object({
  content: z.array(paragraphNodeSchema)
});
function isValidMultilineContent(content) {
  return multilineContentSchema.safeParse(content).success;
}
export {
  inlineNodeSchema,
  isValidMultilineContent,
  multilineContentSchema,
  paragraphNodeSchema,
  placeholderNodeSchema,
  singleLineContentSchema,
  textNodeSchema
};
//# sourceMappingURL=schema.js.map
